<template>
  <div @click="activate" @keydown.esc="away" @keydown.enter="activate"
    class="value-display list-group-item col w-100 d-flex flex-row justify-content-between p-0 align-items-center"
    type="button" tabindex="0" ref="value-display" aria-haspopup="true" aria-expanded="false">
    <span data-toggle="tooltip" data-placement="center" class="ml-2 preview"
      :class="{ empty: selectedItems.length === 0 }">
      <span v-if="selectedItems.length >= 1" class="select-badge">
        {{ selectedItems.length }}
      </span>
      <span v-for="(item, index) in selectedItems" :key="index"> 
        {{ formatFacetLabel(renderTitle(item)) }}<span v-if="index < selectedItems.length - 1">,
        </span>
      </span>
      <span v-if="selectedItems.length <= 0">
        {{ placeholder || "- Any -" }}
      </span>
    </span>
    <!-- Display selected item titles or placeholder -->
    <!-- <span v-if="selectedItems.length > 0">
            <span v-for="(item, index) in selectedItems" :key="index">   
                {{ item.title }}<span v-if="index < selectedItems.length - 1">,  
                </span>
            </span>
        </span> -->
    <div class="ecl-select__icon">
      <svg class="ecl-icon ecl-icon--s ecl-icon--rotate-180 ecl-select__icon-shape" focusable="false"
        aria-hidden="true">
        <use xlink:href="@/assets/img/ecl/icons.svg#corner-arrow"></use>
      </svg>
    </div>
  </div>

</template>

<script>
export default {
  name: "ECSelectDisplay",
  props: {
    title: String,
    text: String,
    placeholder: String,
    showOptions: Function,
    away: Function,
    selectedItems: Array,
    fieldId: String,
    selected: Boolean
  },
  methods: {
     formatFacetLabel(label) {
    if (!label) return '';
    const map = {
      use_cases: 'Use Cases',
      covid_19_data_stories: 'COVID-19 Data Stories',
      factsheets_reports: 'Factsheet Reports',
      country_insight: 'Country Insight',
      data_stories: 'Data Stories'
    };
    if (map[label]) return map[label];
    return label.charAt(0).toUpperCase() + label.slice(1);
  },
    activate() {
      this.showOptions();
      this.$refs["value-display"].focus();
    },
    isNestedTitle(item) {
      return item.title && typeof item.title === 'object';
    },

    // Render title dynamically based on available language keys
    renderTitle(item) {
      if (this.fieldId === "country" && String(item?.id).toLowerCase() === "eu") {
        return "Europe";
      }

      if (this.isNestedTitle(item)) {
        const titleMap =
          item.title.title && typeof item.title.title === 'object'
            ? item.title.title
            : item.title;
        return titleMap[this.$i18n.locale]
          || titleMap.en
          || Object.values(titleMap).find(value => typeof value === 'string')
          || '';

      }

      return item.title; // Direct title if it's a simple string
    }
  }
}
</script>

<style scoped lang="scss">
.value-display {
  min-height: 48px;
  border-color: #707070;

  &:focus {
    border-width: 3px;
  }

  &:hover {
    border-color: var(--primary);

    .ecl-select__icon {
      background: var(--primary);
    }
  }
}



.select-badge {
  align-items: center;
  background-color: #0e47cb;
  border-radius: .75rem;
  color: #fff;
  display: inline-flex;
  height: auto;
  justify-content: center;
  min-width: 35px;
  padding: 0.25rem;
  position: relative;
  text-align: center;
  margin-right: 5px;

}

.preview {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  white-space: nowrap;
}
</style>
